import CloseIcon from '@mui/icons-material/Close';
import { Fragment, useState } from 'react';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
import { DEFAULT_REGION } from 'types/Region';
import { FilterItem, FilterType } from 'util/formatFilterStrings';
import SavedSearchFilter from './SavedSearchFilter';
interface AppliedFiltersProps {
    isClearButtonVisible?: boolean;
    Icon?: React.ElementType;
    options?: FilterItem[] | { type: string; text: string }[];
    onClearFilter?: (filterType: FilterType) => void;
    onSaveFilterClick?: (title: string) => void;
    action?: 'clear' | 'edit';
    isSavedFilter?: boolean;
}

export default function AppliedFilters({
    isClearButtonVisible = false,
    Icon = CloseIcon,
    options = [],
    onClearFilter,
    onSaveFilterClick,
    action = 'edit',
    isSavedFilter = false,
}: AppliedFiltersProps) {
    const [selected, setSelected] = useState('');
    const [editFilterModalVisible, setEditFilterModalVisible] = useState(false);
    const { setPropertyRequestQueryFilter, setLocalFilters, setRegion, selectedFilter, setSelectedFilter, propertyRequestQueryFilter } =
        usePropertyRequestsStore();

    const hasAnyTruthyValue = Object.values(propertyRequestQueryFilter).some(Boolean);

    return (
        <>
            <div className="flex flex-wrap items-center px-4 mt-2 gap-2 ">
                {options.map((filter, index) => (
                    <Fragment key={index}>
                        <div
                            className={`flex gap-4 items-center justify-between rounded-lg cursor-pointer ${
                                selectedFilter === filter.text ? 'bg-my-green text-white border-my-green' : 'bg-gray-50 text-black/80'
                            } ${isSavedFilter ? 'border border-gray-300' : 'border border-blue-400'}`}
                            onClick={() => {
                                if (onSaveFilterClick) {
                                    if (hasAnyTruthyValue && selectedFilter) {
                                        setSelectedFilter('');
                                        setPropertyRequestQueryFilter({});
                                        setLocalFilters({});
                                        setRegion(DEFAULT_REGION);
                                    } else {
                                        setSelectedFilter(filter.text);
                                        onSaveFilterClick?.(filter.text);
                                    }
                                } else {
                                    setSelectedFilter('');
                                    onClearFilter?.(filter?.type as FilterType);
                                }
                            }}
                        >
                            <p className="px-4 py-2 w-fit rounded-lg flex">{filter.text}</p>
                            <button
                                onClick={(e) => {
                                    if (!isClearButtonVisible) {
                                        if (action === 'clear') {
                                            e.stopPropagation();
                                            setSelectedFilter('');
                                            onClearFilter?.(filter?.type as FilterType);
                                        } else {
                                            e.stopPropagation();
                                            setSelected(filter.text);
                                            setEditFilterModalVisible(true);
                                        }
                                    }
                                }}
                            >
                                <Icon className="h-6 w-6 mr-2  cursor-pointer" />
                            </button>
                        </div>
                    </Fragment>
                ))}

                {isClearButtonVisible && (
                    <h3
                        className="font-medium text-base cursor-pointer"
                        onClick={() => {
                            setSelectedFilter('');
                            setPropertyRequestQueryFilter({});
                            setLocalFilters({});
                            setRegion(DEFAULT_REGION);
                        }}
                    >
                        Clear All
                    </h3>
                )}
            </div>
            <SavedSearchFilter visible={editFilterModalVisible} onClose={() => setEditFilterModalVisible(false)} filterTitle={selected} />
        </>
    );
}
